export default { //eslint-disable-line
	NODE_ENV: "prod",
	ROOT_API: "https://api.cljrelacoesinstitucionais.com.br",
};
